import { render, staticRenderFns } from "./ListPagination.vue?vue&type=template&id=6a5b43a8&scoped=true"
import script from "./ListPagination.vue?vue&type=script&lang=js"
export * from "./ListPagination.vue?vue&type=script&lang=js"
import style0 from "./ListPagination.vue?vue&type=style&index=0&id=6a5b43a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b43a8",
  null
  
)

export default component.exports